<template>
  <div class="home-page-wrap  haslogin" id="section0">

    <div class="w-full bg-white" id="section1" >
      <div class="max-w-[1980px] m-auto" :class="topbannerclass" ></div>
    </div>
    <div class="py-1 bg-white rounded-md menu-select w1200 mt-6 shadow-md" >
      <!-- <div><img src="../../assets/images/index/xuekeziyuan_title.png" class="block w-full object-contain"></div> -->
      <!-- style="mask-image: linear-gradient(to bottom, #2bb9c3 82%, transparent 108%);" -->
      <div><img src="../../assets/images/index/three/new_xueke1.jpg" class="block w-full object-contain" ></div>
      <div class="mt-8">
        <MyButtonRadio :list="gradeList" title="年级" @selected="getSelectedGrade"   :selected-id="selectedGrade"></MyButtonRadio>
        <MyButtonRadio :list="sujectList" title="学科" @selected="getSelectedSubject" :selected-id="selectSubject"></MyButtonRadio>
        <MyButtonRadio :list="periodList" title="学期" @selected="getSelectedPeriod" :selected-id="selectedPeriod"></MyButtonRadio>
        <div class="flex justify-end relative top-[-20px]">
          <el-input type="text" v-model="keyword" style="width: 260px;" @change="doSearch" placeholder="请输入课程关键字, 回车搜索" />
          <button class="px-12 py-1 mx-4 text-lg text-white bg-yellow-500 hover:bg-yellow-600" @click="doSearch">搜索</button>
        </div>

      </div>
     
    </div>
    <div class="flex flex-wrap justify-between course-list-section w1200 my-4!">
      <!-- <CourseItem v-for="item of list" :key="item.id" :info="item" v-show="item.id==78|| item.id==79||item.id==80"/> -->
      <!-- <CourseItem v-for="item of list" :key="item.id" :info="item" /> -->
      <CourseItem v-for="item of list" :key="item.id" :info="item" v-show="list.length>0"/>
      <el-card   v-show = "list.length==0" style="width: 100%;">
        <el-result
          icon="error"
          title="当前分类或关键字未查询到相关资源">
        </el-result>
      </el-card>
    </div>
    <div class="flex  w1200 bg-[#e3effd] h-[100px] justify-center items-center cursor-pointer" @click="$router.push({path:'/course/list',query:{grade:99,subject:99,period:99,keyword:''}})"  id="section2">
      <!-- <el-pagination background :page-size="9" :current-page="currentPageNum" layout="prev, pager, next" :total="totalNum" @current-change="pageChange"></el-pagination> -->
      <div class="font-bold color-[black] text-[18px] mr-1">更多资源</div>
      <el-icon color="#000000" size="18"><ArrowRightBold /></el-icon>
    </div>
    <!-- 科学素养 -->
    <div class=" bg-white rounded-md menu-select w1200" style="margin-top: 20px;"  id="section3">
      <!-- <div><img src="../../assets/images/index/kexuesuyang_title.png" class="block w-full object-contain"></div> -->

      <div><img src="../../assets/images/index/three/new_kexue.jpg" class="block w-full object-contain"></div>
      <div class="grid-cols-3 grid gap-4 mt-8">
        <img  @click="jumpOut('https://kxsy.ooowin.com/schoolteach/list')" src="../../assets/images/index/xiaoneijiaoxue.png" alt="" class="w-[400px] h-[auto] cursor-pointer transform transition-transform duration-300 hover:scale-105 hover:brightness-125">
        <img @click="jumpOut('https://kxsy.ooowin.com/outschoolstudy/list?courseId=341&subtype=1')" src="../../assets/images/index/kexuetongbu.png" alt=""  class="w-[400px] h-[auto]  cursor-pointer  transform transition-transform duration-300 hover:scale-105 hover:brightness-125">
        <img  @click="jumpOut('https://kxsy.ooowin.com/outschoolstudy/list?courseId=370&subtype=3')" src="../../assets/images/index/kexuetuozhan.png" alt=""  class="w-[400px] h-[auto]  cursor-pointer  transform transition-transform duration-300 hover:scale-105 hover:brightness-125">
        <!-- <img @click="jumpOut('http://ooowin.teacher.growlib.com/login?VNK=e949c596')" src="../../assets/images/index/xunikexue.png" alt=""  class="w-[400px] h-[auto]  cursor-pointer  transform transition-transform duration-300 hover:scale-105 hover:brightness-125"> -->
      </div>
     
    </div>
     <!-- 劳动素养 -->
    <div class=" bg-white rounded-md menu-select w1200" style="margin-top: 60px;" >
      <!-- <div><img src="../../assets/images/index/laodongsuyang_title.png" class="block w-full object-contain"></div> -->
       <div><img src="../../assets/images/index/three/laodong.jpg" class="block w-full object-contain"></div>
      <div class="grid-cols-3 grid gap-6 mt-8">
        <img @click="jumpOut('https://ld.ooowin.com/')" src="../../assets/images/index/laodongqingdan.png" alt="" class="w-[368px] h-[auto] cursor-pointer transform transition-transform duration-300 hover:scale-105 hover:brightness-125">
        <img  @click="jumpWithQueryObj({subject:7})" src="../../assets/images/index/ketanglaodong.png" alt=""  class="w-[368px] h-[auto]  cursor-pointer  transform transition-transform duration-300 hover:scale-105 hover:brightness-125">
        <img  @click="jumpWithQueryObj({keyword:'木艺'})" src="../../assets/images/index/ketangmugong.png" alt=""  class="w-[368px] h-[auto]  cursor-pointer  transform transition-transform duration-300 hover:scale-105 hover:brightness-125">
      </div>
     
     
    </div>
    <!--  -->
    <div   id="section4" style="height: 60px;"></div>
    <!-- 教师培训 -->
    <div class=" bg-white rounded-md menu-select w1200 mb-20!"  >
      <!-- <div><img src="../../assets/images/index/jiaoshipeixun_title.png" class="block w-full object-contain"></div> -->
      <div><img src="../../assets/images/index/three/jiaoshi.jpg" class="block w-full object-contain"  ></div>
      <div class="mt-4"  @click="jumpOut('https://kxsy.ooowin.com/teacher/develop')" >
        <img src="../../assets/images/index/jiaoshipeixun.png" class="block rounded-[10px] cursor-pointer" alt="">
      </div>
     
    </div>
    <!-- 更多产品,暂时隐藏 -->
    <div class=" bg-white rounded-md menu-select w1200 p-4 " style="margin-top: 60px; margin-bottom: 100px;"  v-if="false">
      <div class="font-bold text-xl">更多产品</div>
      <div class="grid grid-cols-2 gap-10 mt-4">
        <div class="justify-start flex flex-col items-center">
          <img src="../../assets/images/index/zhejiaoxuexi.png" class="h-[285px] w-[auto]">
          <div class="flex flex-col justify-start items-center pt-4">
            <p class="text-center font-bold text-[18px]">浙教学习APP</p>
            <div class="mt-4">浙教学习app是一款权威的中小学教材配套学习客户端应用，浙教学习软件拥有英语、数学、语文等学科同步辅导课程资源，梳理每科知识点，辅助课后辅导，助力孩子有效提分。</div>
            <div class="jump-btn mt-4" @click="jumpOut('https://app.zhihuiliu.com/zjyy/')">点击体验</div>
          </div>
        </div>
        <div class="justify-center flex flex-col items-center">
          <img src="../../assets/images/index/qingyundan.png" class="w-[auto] h-[285px]">
          <div class="flex flex-col justify-start items-center pt-4">
            <p class="text-center font-bold text-[18px]">青云端微信公众号矩阵</p>
            <div class="mt-4">
              
              青云端是一个为全省中小学提供优质学习方案和移动学习资源的教育服务平台，包含多个微信公众号和小程序，海量配套教辅资源，全方位服务中小学生。
            
            </div>
            <div class="mt-4 flex justify-center items-center">
              <img src="../../assets/images/index/qrcode_list.png" style="width: 90%;display: block;">
            </div>
          </div>
        </div>
        <div class="justify-start flex flex-col items-center mt-4">
          <img src="../../assets/images/index/laodongqingdan_web.png" class="w-[360px] h-[285px]">
          <div class="flex flex-col justify-start items-center pt-4">
            <p class="text-center font-bold text-[18px]">浙江省中小学劳动清单服务平台</p>
            <div class="mt-4">
              
              服务于浙江省中小学教研员、教师、家长和学生，为学校、教研员提供劳动清单模板管理、劳动清单任务布置等功能，为学生提供学习目标、活动展示、活动收获等任务提交功能。
            
            </div>
            <div class="jump-btn mt-4" @click="jumpOut('https://ldgl.ooowin.com/login')">点击体验</div>
          </div>
        </div>
        <div class="justify-start flex flex-col items-center mt-4">
          <img src="../../assets/images/index/zhsj.png" class="w-[360px] h-[285px]">
          <div class="flex flex-col justify-start items-center pt-4">
            <p class="text-center font-bold text-[18px]">综合实践活动网</p>
            <div class="mt-4">
              
              以浙江教育出版社《综合实践活动》为基础的线上课程，包含纸质图书资源及海量综合实践课程相关资讯。
            
            </div>
            <div class="jump-btn mt-4" @click="jumpOut('https://zhsj.ooowin.com/')">点击体验</div>
          </div>
        </div>
      </div>
      <div class="flex h-[100px]"></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import CommonUtils from "../../utils/CommonUtils";
import MyButtonRadio from "../../components/MyButtonRadio.vue";
import CourseItem from "./CourseItem.vue";
import CourseService from "../../apis/CourseService";
import Constants from "../../constants/Index";
import MittUtil from "../../utils/MittUtil";
import { curShowList } from "./curShowList";
import { ArrowRightBold } from "@element-plus/icons-vue";

const topbannerclass = ref("header-banner1");
const changeCls = () => {
  if (topbannerclass.value === "header-banner1") {
    topbannerclass.value = "header-banner2";
  } else {
    topbannerclass.value = "header-banner1";
  }
};
const list = ref([]);
const isLogin = ref(false);
const userName = ref("");
const selectedGrade = ref(99);
const selectSubject = ref(99);
const selectedPeriod = ref(99);
const totalNum = ref(0);
const currentPageNum = ref(1);
const keyword = ref('');
const router = useRouter();
const gradeList = ref([
  { id: 99, text: "不限" },
  // { id: 0, text: "通用" },
  { id: 13, text: "学前" },
  { id: 1, text: "一年级" },
  { id: 2, text: "二年级" },
  { id: 3, text: "三年级" },
  { id: 4, text: "四年级" },
  { id: 5, text: "五年级" },
  { id: 6, text: "六年级" },
  { id: 7, text: "七年级" },
  { id: 8, text: "八年级" },
  { id: 9, text: "九年级" },
]);
const sujectList = ref([
  { id: 99, text: "不限" },
  { id: 0, text: "通用" },
  { id: 1, text: "语文" },
  { id: 2, text: "数学" },
  { id: 3, text: "英语" },
  { id: 4, text: "科学" },
  { id: 5, text: '道德与法治' },
  { id: 6, text: '历史与社会' },
  { id: 7, text: '劳动' },
  { id: 8, text: '信息科技' },
  { id: 9, text: '素质拓展' }
]);
const periodList = ref([
  { id: 99, text: "不限" },
  { id: 1, text: "上学期" },
  { id: 2, text: "下学期" },
]);

const showHandle = (item: any) => {
  console.log("=============is show course item");
  curShowList.forEach((c: any) => {
    return c.id == item.id;
  })
};

const jumpWithQueryObj = (queryObj:object)=>{
  router.push({
    path: '/course/list',
    query: {
      grade: 99,
      subject: 99,
      period: 99,
      keyword: '',
      ...queryObj
    }
  });
}
const getSelectedGrade = (item: any) => {
  console.log(item);
  selectedGrade.value = item.id;
  getList(1, 9, selectedGrade.value, selectSubject.value, selectedPeriod.value, keyword.value);
};
const getSelectedSubject = (item: any) => {
  selectSubject.value = item.id;
  getList(1, 9, selectedGrade.value, selectSubject.value, selectedPeriod.value, keyword.value);
};
const getSelectedPeriod = (item: any) => {
  selectedPeriod.value = item.id;
  getList(1, 9, selectedGrade.value, selectSubject.value, selectedPeriod.value, keyword.value);
};

// pageNum:string,
// pageSize: string,
// grade: string,
// course: string,
// term: string,
// name:string,
const getList = (pageNum: number | string, pageSize: string | number, grade?: string | number, course?: string | number, term?: string | number, name?: string) => {
  const postData = {
    pageNum,
    pageSize,
    name,
  };
  if (grade != 99) {
    postData.grade = grade;
  }
  if (course != 99) {
    postData.course = course;
  }
  if (term != 99) {
    postData.term = term;
  }
  //@ts-ignore
  CourseService.getList(postData).then((res) => {
    if (res.code == 1) {
      list.value = res.data && res.data.list;
      totalNum.value = res.data && Number(res.data.total);
      currentPageNum.value = pageNum as number;
    }
  });
};
//监听登录状态
MittUtil.on("isLogin", (e) => {
  isLogin.value = e;
});
onMounted(() => {
  if (CommonUtils.isLogin()) {
    isLogin.value = true;
    userName.value = CommonUtils.getLocalStore(Constants.NickNamekey);
  }
  getList(1, 9);
});

const doSearch = () => {
  // getList(1, 9, selectedGrade.value, selectSubject.value, selectedPeriod.value, keyword.value);
  jumpWithQueryObj({keyword:keyword.value});
};
//分页事件
const pageChange = (num: any) => {
  getList(num, 9, selectedGrade.value, selectSubject.value, selectedPeriod.value, keyword.value);
};
const jumpOut = (url: string) => {
  // window.location.href = url;
   window.open(url, '_blank');
};
</script>
<style lang="scss">
.course-list-section {
  &::after {
    content: "";
    width: 32%;
    display: block;
    height: auto;
  }
}
.title-and-seperator {
  .totalNum {
    height: 72px;
    width: 176px;
    line-height: 72px;
    padding-left: 17px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMCAYAAACqYHctAAAAAXNSR0IArs4c6QAAAEVJREFUCB1j/J+a6snAwDCL4f9/GSD9mIGRMZ0JSQDIZJAFSs5kgqoACcCALBNQ+RMYD0o/BmlPQ5IAm4mmCA+XkV5OAgCjniQ3TG2KRgAAAABJRU5ErkJggg==) no-repeat 6px;
    background-size: auto 10px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 1000px;
      height: 0;
      left: 100%;
      top: 50%;
      border-bottom: 1px solid #ffffff;
    }
  }
}
.mainContent:before {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  right: 150px;
  width: 10%;
  height: 100px;
  z-index: 3;
  // background: url("../../assets/images/common/img_qxz.png") no-repeat 0 top;
  background-size: auto 100%;
}
.mainContent {
  padding-bottom: 175px;
}
.conTop {
  height: 363px;
  .advert {
    width: 890px;
    height: 350px;
    border-radius: 4px;
  }
  .mineInfor {
    width: 300px;
    height: 100%;
    background: url("../../assets/images/index/bg_login.png") no-repeat;
    background-size: 100% 100%;
    .topBox {
      height: 50%;
      position: relative;
    }
    .bottomBox {
      height: 50%;
      line-height: 30px;
      padding-top: 30px;
      box-sizing: border-box;
      font-size: 20px;
    }
    .header {
      height: 70px;
      width: 70px;
      border-radius: 50%;
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    button {
      width: 100px;
      height: 40px;
      border-radius: 20px;
      margin: 0 10px;
      font-size: 18px;
    }
  }
}

//banner
.advert {
  position: relative;
  ul,
  li {
    height: 100%;
  }
  ul li img {
    width: 100%;
    height: 100%;
  }
  .toLeft,
  .toRight {
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -34px;
    width: 46px;
    height: 68px;
    cursor: pointer;
    display: none;
  }
  .toLeft {
    background: url("../../assets/images/index/btn_jt_left.png") no-repeat;
    left: 15px;
  }
  .toRight {
    background: url("../../assets/images/index/btn_jt_right.png") no-repeat;
    right: 15px;
  }
  .bannerBtns {
    position: absolute;
    bottom: 17px;
    left: 50%;
    transform: translateX(-50%);
  }
  .bannerBtns span {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 8px;
    cursor: pointer;
  }
  .bannerBtns span.ac {
    background-color: #fff;
  }
}

//登录的时候显示
.loginShow.mineInfor {
  .header {
    position: static;
    display: inline-block;
    transform: translate(0, 0);
    margin-top: 42px;
  }
  .header img {
    width: 100%;
    height: 100%;
  }
  .userName {
    font-size: 16px;
    color: #fff;
    line-height: 36px;
  }
  a {
    display: inline-block;
    height: 46px;
    border-radius: 23px;
    width: 240px;
    line-height: 46px;
  }
}
.gradeList {
  background-color: #c8fbff;
  border-radius: 16px;
}
.gradeList .gradeLi.loginShow {
  .listBook li {
    width: 170px;
    margin-right: 45px;
    padding-top: 0;
    box-shadow: none;
    img {
      width: 100%;
    }
  }
  .listBook li:last-of-type {
    margin-right: 0;
  }
  .listBook .hasNoData {
    background: url("../../assets/images/index/img_zy_nokc.png") no-repeat top center;
    background-size: auto 200px;
    padding: 200px 0 0;
    width: 100%;
    p {
      line-height: 60px;
      height: 60px;
      text-align: center;
      font-size: 24px;
    }
  }
}

.studySection {
  background-color: #91e6ec;
  padding: 35px 0;
  text-align: center;
  ul {
    display: inline-block;
  }
  ul li {
    width: 130px;
    .picBox {
      width: 60px;
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      margin: 0 auto;
      border-radius: 50%;
      border: 4px #fff solid;
      /* background-color: #6094eb;*/
    }
    .learn1 {
      background: url("../../assets/images/index/bg_yw.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn2 {
      background: url("../../assets/images/index/bg_sx.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn3 {
      background: url("../../assets/images/index/bg_yy.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn4 {
      background: url("../../assets/images/index/bg_kx.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn5 {
      background: url("../../assets/images/index/bg_js.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn6 {
      background: url("../../assets/images/index/bg_tzxkc.png") no-repeat;
      background-size: 100% 100%;
    }
    .learn7 {
      background: url("../../assets/images/index/bg_xxkc.png") no-repeat;
      background-size: 100% 100%;
    }
    p {
      line-height: 28px;
    }
  }
}
.unlogin {
  .unloginShow {
    display: block;
  }
  .loginShow {
    display: none;
  }
}
.haslogin {
  .unloginShow {
    display: none;
  }
  .loginShow {
    display: block;
  }
}
.layui-layer {
  border-radius: 18px;
  font-size: 16px;
  .layui-layer-title {
    text-align: center;
    padding: 0;
    background-color: #2bb9c3;
    height: 38px;
    line-height: 38px;
    color: #fff;
    font-size: 16px;
    border: 0;
  }
  .layui-layer-btn {
    text-align: center;
    margin-bottom: 40px;
    padding: 0;
    a {
      width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 3px;
      margin: 0 15px;
      padding: 0;
      border: 0;
    }
    .layui-layer-btn0 {
      background-color: #dedede;
      color: #646464;
    }
    .layui-layer-btn1 {
      background-color: #1f920c;
      color: #fff;
    }
  }
  .layui-layer-setwin {
    top: 11px;
    .layui-layer-close1 {
      background: url("../../assets/images/common/btn_tc_close.png") no-repeat;
    }
  }
}
.layui-layer.layalert .layui-layer-content {
  height: 110px;
  .noticeFont {
    background: url("../../assets/images/common/alert_icon.png") no-repeat;
    background-size: auto 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 210px;
    transform: translate(-50%, -50%);
  }
}
.layui-layer.layalert .layui-layer-btn a:last-of-type {
  background-color: #1f920c;
  color: #fff;
}

// 新的样式 20250318
.home-page-wrap{
  .header-banner {
    background: url("../../assets/images/index/banner.png") no-repeat center;
    background-size: cover;;
    background-position: center center;
    height: 270px;
  }
  .header-banner1 {
    background: url("../../assets/images/index/topbanner3.jpg") no-repeat center;
    background-size: cover;;
    background-position: center center;
    height: 270px;
  }
  .header-banner2 {
    background: url("../../assets/images/index/topbanner3.jpg") no-repeat center;
    background-size: cover;;
    background-position: center center;
    height: 270px;
  }
  .jump-btn {
    width: 180px;
    height: 50px;
    line-height: 50px;
    background: #48D1C8;
    box-shadow: 0px 2px 15px 0px rgba(26,198,181,0.18);
    border-radius: 20px; 
    text-align: center;
    font-size: 18px;
    color: #FFFFFF;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>
